// Props
type GenericCardProps = {
  title?: string;
  description?: string;
  extra?: string;
  extraTitle?: string;
  extraDescription?: string;
  children?: React.ReactNode;
  topRight?: React.ReactNode;
  bgColor?:
    | "white"
    | "50"
    | "100"
    | "200"
    | "300"
    | "400"
    | "500"
    | "600"
    | "700"
    | "800"
    | "900";
  textColor?: "primary" | "secondary" | "tertiary" | "white";
};

const GenericCard = ({
  title,
  description,
  extra,
  extraTitle = "heading-lg",
  extraDescription = "text-txt-md",
  bgColor = "white",
  children,
  topRight,
  textColor = "primary",
}: GenericCardProps) => {
  const bgColorClass =
    bgColor === "white" ? "bg-white" : `bg-background-${bgColor}`;
  const textColorClass =
    textColor === "white"
      ? "text-white"
      : textColor === "primary"
      ? "text-primary"
      : textColor === "secondary"
      ? "text-secondary"
      : "text-tertiary";
  return (
    <div
      className={`flex w-full flex-col rounded-[20px] p-4 md:p-6 ${bgColorClass} ${extra} overflow-auto`}
    >
      <div className="flex w-full flex-col">
        <div className="flex w-full flex-row justify-between md:items-start">
          <div className="flex flex-col">
            <h4 className={`${extraTitle} ${textColorClass}`}>{title}</h4>
            <p className={`${extraDescription} ${textColorClass} mt-1 `}>
              {description}
            </p>
          </div>

          <div className="mt-4 md:ml-4 md:mt-0">{topRight}</div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default GenericCard;
